import { render, staticRenderFns } from "./InquiryForm.vue?vue&type=template&id=619baf35&scoped=true"
import script from "./InquiryForm.vue?vue&type=script&lang=js"
export * from "./InquiryForm.vue?vue&type=script&lang=js"
import style0 from "./InquiryForm.vue?vue&type=style&index=0&id=619baf35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619baf35",
  null
  
)

export default component.exports